<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "App",
};
</script>
<style>
@import url("./assets/iconfont.css");
html {
  font-family: NotoSansHant, Helvetica, Arial, sans-serif;
  font-weight: 350;
  font-size: 62px;
}

@media (min-width: 1024px) {
  html {
    font-size: 62px;
  }
}

@media (min-width: 1280px) {
  html {
    font-size: 67px;
  }
}

@media (min-width: 1366px) {
  html {
    font-size: 71px;
  }
}

@media (min-width: 1440px) {
  html {
    font-size: 75px;
  }
}

@media screen and(min-width: 1920px) {
  html {
    font-size: 100px;
  }
}

body {
  margin: 0;
  padding: 0;
  font-size: 12px;
  background-color: white;
  color: #474747;
}

a {
  display: inherit;
  text-decoration: none;
}

a:visited {
  color: #474747;
}

a .iconfont {
  color: #717171;
}

img {
  border: none;
}

.actable {
  cursor: pointer;
}
</style>
